<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "ClientDetailsView"
    }
</script>

<style scoped>

</style>